import { render } from "./Requisites.vue?vue&type=template&id=65c27c96&ts=true"
import script from "./Requisites.vue?vue&type=script&lang=ts"
export * from "./Requisites.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__